import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ModalCard from "../../../components/ModalCard";
import {
  BGColor02,
  blackShade19,
  blueColor04,
  blueColor100,
  border27,
  greyColor02,
  whiteColor,
} from "../../../configs/styles/muiThemes";

function MoreImageViewModal({
  modal,
  setModal,
  setIsImageIssueModal,
  srcImage,
  heading,
}) {
  return (
    <ModalCard
      open={modal}
      handleClose={() => {
        setModal({
          show: false,
          image: "",
          heading: "",
        });
      }}
      width="30%"
      modalType="inside"
    >
      <Box sx={styles.card}>
        <Typography
          variant="h3"
          fontSize={18}
          fontWeight={600}
          lineHeight="34px"
          color={blackShade19}
          textAlign="center"
          p="15px 50px"
        >
          {heading}
        </Typography>
        <Box
          p="10px"
          sx={{
            background: whiteColor,
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "4px",
              height: "4px",
              borderRadius: "50px !important",
            },
            "&::-webkit-scrollbar-thumb": {
              // background: '#d0d3da',
              background: "rgba(0,0,0,0.1)",
            },
            "&::-webkit-scrollbar-track": {
              background: "rgba(0,0,0,0.05)",
            },
          }}
          height={"400px"}
        >
          <Grid container spacing={1}>
            {srcImage?.map(
              (imageUrl, index) =>
                imageUrl && (
                  <Grid item md={3}>
                    <Box
                      component="img"
                      src={imageUrl}
                      alt=""
                      sx={styles.logoImg}
                      key={index}
                      onClick={() => {
                        setIsImageIssueModal(imageUrl);
                      }}
                    />
                  </Grid>
                )
            )}
          </Grid>
        </Box>
      </Box>
    </ModalCard>
  );
}

export default MoreImageViewModal;

const styles = {
  card: {
    backgroundColor: BGColor02,
    borderRadius: "15px",
    overflow: "hidden",
  },

  logoImg: {
    color: blueColor04,
    width: { xs: "52px", md: "84px" },
    height: { xs: "52px", md: "84px" },
    border: border27,
    objectFit: "contain",
    borderRadius: "8px",
    cursor: "pointer",
  },
};
